import { FC, Suspense } from 'react';
import {
  Layout as BaseLayout,
  Card,
  Carousel,
  Flex,
  Grid,
  Image,
  Typography,
} from 'antd';
import { Outlet } from 'react-router-dom';
import { Logo } from '../../logo';
import Schema from '../../../assets/images/schema.png';
import Card1 from '../../../assets/images/slider/Card-1.png';
import Card2 from '../../../assets/images/slider/Card-2.png';
import Card3 from '../../../assets/images/slider/Card-3.png';
import { AuthContextProvider } from '../../../contexts/AuthContext';
import { useAppSelector } from '@/hooks/useAppSelector';
import { selectUser } from '@/slice/user';
import './index.scss';
import { useApp } from '@/components/app';

const AuthLayout: FC = () => {
  const user = useAppSelector(selectUser);
  const { lg } = Grid.useBreakpoint();
  const { showWelcomeBanner } = useApp().app;

  const isAdmin = user?.role === 'admin';

  return (
    <AuthContextProvider>
      <BaseLayout
        style={{ minHeight: '100dvh', height: '100%' }}
        className={`${!isAdmin && 'user-layout'} auth-layout`}
      >
        {lg && showWelcomeBanner && (
          <BaseLayout.Sider className={'sider'} width={'40%'}>
            <div className={'logo-wrapper'}>
              <Logo />
            </div>

            {/* <div className={'schema-wrapper'}>
                <img src={Schema} alt={''} />
              </div> */}
            <div className="schema-wrapper" style={{ width: '100%' }}>
              <ImageSlider />
            </div>
          </BaseLayout.Sider>
        )}

        {!lg && showWelcomeBanner && (
          <div className="schema-wrapper mobile" style={{ width: '100%' }}>
            <ImageSlider />
          </div>
        )}

        <BaseLayout style={{ padding: lg ? '0 48px' : '0 24px' }}>
          <Suspense>
            <Outlet />
          </Suspense>
        </BaseLayout>
      </BaseLayout>
    </AuthContextProvider>
  );
};

const ImageSlider = () => {
  const { lg } = Grid.useBreakpoint();

  return (
    <Carousel
      autoplay
      style={{
        overflow: 'hidden',
        width: '100%',
        float: 'right',
        textAlign: 'center',
        padding: lg ? '48px 15%' : '24px 10%',
        color: '#192126',
      }}
    >
      <Flex vertical justify="center" align="center">
        <img
          src={Card1}
          alt={''}
          style={{
            maxWidth: lg ? '400px' : '225px',
            height: 'auto',
            marginBottom: lg ? '24px' : '0',
            marginTop: lg ? '0' : '24px',
            display: 'inline-block',
          }}
        />
        <Typography.Title level={3} style={{ color: '#192126' }}>
          More Broker Leads, Less Hassle
        </Typography.Title>
        <Typography.Text
          style={{
            color: '#49586F',
            fontSize: 16,
            lineHeight: '24px',
          }}
        >
          Connect with 1,000+ active franchise consultants and book meetings
          instantly to grow your brand.
        </Typography.Text>
      </Flex>
      <Flex gap={16} vertical justify="center" align="center">
        <img
          src={Card2}
          alt={''}
          style={{
            maxWidth: lg ? '400px' : '225px',
            height: 'auto',
            marginBottom: lg ? '24px' : '0',
            marginTop: lg ? '0' : '24px',
            display: 'inline-block',
          }}
        />
        <Typography.Title level={3} style={{ color: '#192126' }}>
          Streamlined Communication
        </Typography.Title>
        <Typography.Text
          style={{
            color: '#49586F',
            fontSize: 16,
            lineHeight: '24px',
          }}
        >
          Connect quickly and easily—send a message, schedule a call, and keep
          conversations moving without delays.
        </Typography.Text>
      </Flex>
      <Flex gap={16} vertical justify="center" align="center">
        <img
          src={Card3}
          alt={''}
          style={{
            maxWidth: lg ? '400px' : '225px',
            height: 'auto',
            marginBottom: lg ? '24px' : '0',
            marginTop: lg ? '0' : '24px',
            display: 'inline-block',
          }}
        />
        <Typography.Title level={3} style={{ color: '#192126' }}>
          Streamlined Communication
        </Typography.Title>
        <Typography.Text
          style={{
            color: '#49586F',
            fontSize: 16,
            lineHeight: '24px',
          }}
        >
          Reserve payment upfront and only pay after a confirmed
          meeting—ensuring confidence for both sides.
        </Typography.Text>
      </Flex>
    </Carousel>
  );
};

export default AuthLayout;
